// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_languages } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchLanguages = async (setLanguages, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_languages();
    if (response.statusText=="OK") {
      const data = response?.data;
      setLanguages(data); // Update state with fetched countries
    } else {
      message.error("Failed to fetch languages.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching languages.");
  }
};
